const industryChainStore = {
    state: {
        chainCategories: [],
        chainCaches: {},

    },
    mutations: {
        setChainCategories(state, val) {
            state.chainCategories = val;
        },
        setChainCaches(state, val) {
            state.chainCaches[val.name] = val.categories;
        }
    },
    actions: {
    }
}

export default industryChainStore